<template>
    <rkm-modal
        ref="RkmModal"
        title="Escolha"
    >
        Deseja cancelar ou reagendar?

        <template v-slot:footer>
            <rkm-button
                @click="cancel"
                color="danger"
            >
                Cancelar
            </rkm-button>

            <rkm-button
                @click="reschedule"
                color="primary"
            >
                Reagendar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import {error, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    data: () => ({
        date: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(date) {
            this.date = date
            this.$refs.RkmModal.show()
        },
        cancel() {
            this.hide()
            this.$emit('cancel', this.date)
        },
        reschedule() {
            this.showConfirmation(
                'Deseja reagendar para a mesma unidade, local de atendimento, CBO, especialidade e profissional?',
                async () => {this.$nextTick().then(() => this.$emit('reschedule', this.date))},
                async () => {this.$nextTick().then(() => this.$emit('destiny', this.date))},
            )

            this.hide()
        },
        hide() {
            this.$refs.RkmModal.hide()
        },
    },
    mixins: [error, repository, stringCase],
}
</script>